import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import { Beat } from "../../../plugins/spinners.plugin";
import Warning from "../../../assets/images/icons/warning.svg";
import { filterCoupons } from "../../../redux/coupons/couponAction";

export default function FilterCouponDropDown({
  payLoad,
  isFilterOpen,
  setFilterState,
}) {
  const dispatch = useDispatch();
  const { isLoading, filtering } = useSelector((state) => state.coupon);

  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    title: "",
    // status: "",
    start_date: "",
  });
  const { title,  start_date } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const handleReset = async () => {
    setData({
      title: "",
      // status: "",
      start_date: "",
    });
    await dispatch(filterCoupons(payLoad, 1));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    if (title  || start_date) {
      setErrorMsg(false);
      let newData = { ...data, ...payLoad };
      try {
        const response = await dispatch(filterCoupons(newData, 1));
        if (response) {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };
  return (
    <>
      <div className="py-5 mt-4 px-5">
        <form className="text-left">
          <div className="grid grid-cols-1">
            <Input.Label
              title={"Title"}
              htmlFor={"title"}
              name={"title"}
              onChange={handleChange}
              autoComplete="off"
              value={title}
              placeholder={"Enter Title"}
            />
            {/* <Input.Select
              title={"Status"}
              name="status"
              htmlFor={"status"}
              value={status}
            >
              <option>Select a status</option>
              <option value={"active"}>Active</option>
              <option value={"inactive"}>Inactive</option>
            </Input.Select> */}

            <Input.DatePicker
              title={"Date"}
              htmlFor={"start_date"}
              name={"start_date"}
              autoComplete="off"
              value={start_date}
              onChange={handleChange}
            />

            <div className="py-8 grid grid-cols-2 gap-6 text-center">
              <Button.Secondary
                disabled={isLoading}
                title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
                className="px-4"
                onClick={handleReset}
                type="button"
              />
              <Button.Primary
                disabled={filtering}
                title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
                className="px-4"
                onClick={handleSubmit}
                type="button"
              />
            </div>
          </div>
          {errorMsg && (
            <div className="flex gap-1 -mt-2">
              <img src={Warning} alt="warning" />
              <p>No value to filter by</p>
            </div>
          )}
        </form>
      </div>
    </>
  );
}
